import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import {
  REQUEST,
  segmentInferenceSuccess,
  segmentInferencePending,
  segmentInferenceFailure,
} from '../../actions/deployments/inference';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error as ErrorAction } from '../../actions/error/error';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* segmentInferenceData(action) {
  try {
    // Phase 13.O: foundation-direct deployments need extra request
    // body fields (segment_id, horizon, samples, quantile_levels,
    // context_length). Pass any non-falsy ones through. Trained-model
    // deployments still work because they ignore these.
    const {
      deployment_id,
      feature_debug = false,
      segment_id,
      horizon,
      samples,
      quantile_levels,
      context_length,
    } = action.payload;

    // Get headers using the same pattern as other sagas
    const headers = getLocalUser();

    if (!headers.Authorization) {
      throw new Error('Authentication token not found');
    }

    // Add content type header
    headers['Content-Type'] = 'application/json';

    const body = {
      parameters: { feature_debug },
    };
    if (segment_id) body.segment_id = segment_id;
    if (horizon) body.horizon = horizon;
    if (samples) body.samples = samples;
    if (quantile_levels) body.quantile_levels = quantile_levels;
    if (context_length) body.context_length = context_length;

    const response = yield call(
      axios.post,
      `${config.API_URL}/inference/deployments/${deployment_id}/infer-segment`,
      body,
      { headers },
    );

    const data = response.data || {};

    // Async path (foundation-direct, scale-to-zero server): the API accepted
    // the job (HTTP 202) and the forecast will arrive later over the realtime
    // WebSocket. Keep the dialog spinning and remember the inference id; the
    // deployment page resolves it on the 'inference.completed' event. Don't
    // pop a success snackbar yet — nothing has been forecast.
    if (data.async && data.inference_id && !data.predictions) {
      yield put(segmentInferencePending({
        inferenceId: data.inference_id,
        deploymentId: data.deployment_id,
      }));
      return;
    }

    // Synchronous path (trained models / Kafka-down fallback): result is here.
    yield put(segmentInferenceSuccess(data));
    yield put({ type: 'SHOW_SUCCESS_SNACKBAR', message: 'Segment inference completed successfully' });

  } catch (error) {
    yield put(ErrorAction(error));
    yield put(segmentInferenceFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, segmentInferenceData);
}
